import { Location } from '@angular/common';
import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IUser } from '../../interfaces/user.interface';
import { AuthService } from '../../services/auth/auth.service';
import { ROUTES } from '../sidebar/sidebar.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: false,
})
export class NavbarComponent implements OnInit {
  private listTitles: any[];
  location: Location;
  currentUser: IUser | null = null;
  mobile_menu_visible: any = 0;
  private toggleButton: any;
  private sidebarVisible: boolean;

  constructor(
    location: Location,
    private element: ElementRef,
    private router: Router,
    private authService: AuthService,
  ) {
    this.location = location;
    this.sidebarVisible = false;
  }

  ngOnInit() {
    this.currentUser = this.authService.getCurrentUser();
    this.listTitles = ROUTES.filter((menuItem) => {
      if (!menuItem.roles || menuItem.roles.length === 0) {
        return true;
      }

      return this.authService.hasRole(menuItem.roles);
    });
    const navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
    this.router.events.subscribe((event) => {
      this.sidebarClose();
      var $layer: any = document.getElementsByClassName('close-layer')[0];
      if ($layer) {
        $layer.remove();
        this.mobile_menu_visible = 0;
      }
    });
  }

  sidebarOpen() {
    const toggleButton = this.toggleButton;
    const body = document.getElementsByTagName('body')[0];
    if (!toggleButton) {
      return;
    }
    setTimeout(function () {
      toggleButton.classList.add('toggled');
    }, 500);

    body.classList.add('nav-open');

    this.sidebarVisible = true;
  }
  sidebarClose() {
    const body = document.getElementsByTagName('body')[0];
    if (this.toggleButton) {
      this.toggleButton.classList.remove('toggled');
    }
    this.sidebarVisible = false;
    body.classList.remove('nav-open');
  }
  sidebarToggle() {
    // const toggleButton = this.toggleButton;
    // const body = document.getElementsByTagName('body')[0];
    var $toggle = document.getElementsByClassName('navbar-toggler')[0];

    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
    const body = document.getElementsByTagName('body')[0];

    if (this.mobile_menu_visible == 1) {
      // $('html').removeClass('nav-open');
      body.classList.remove('nav-open');
      if ($layer) {
        $layer.remove();
      }
      setTimeout(function () {
        $toggle.classList.remove('toggled');
      }, 400);

      this.mobile_menu_visible = 0;
    } else {
      setTimeout(function () {
        $toggle.classList.add('toggled');
      }, 430);

      var $layer = document.createElement('div');
      $layer.setAttribute('class', 'close-layer');

      if (body.querySelectorAll('.main-panel')) {
        document.getElementsByClassName('main-panel')[0].appendChild($layer);
      } else if (body.classList.contains('off-canvas-sidebar')) {
        document
          .getElementsByClassName('wrapper-full-page')[0]
          .appendChild($layer);
      }

      setTimeout(function () {
        $layer.classList.add('visible');
      }, 100);

      $layer.onclick = function () {
        //asign a function
        body.classList.remove('nav-open');
        this.mobile_menu_visible = 0;
        $layer.classList.remove('visible');
        setTimeout(function () {
          $layer.remove();
          $toggle.classList.remove('toggled');
        }, 400);
      }.bind(this);

      body.classList.add('nav-open');
      this.mobile_menu_visible = 1;
    }
  }

  getTitle() {
    let title = this.location.prepareExternalUrl(this.location.path());

    if (title.charAt(0) === '#') {
      title = title.slice(1);
    }

    const normalizedTitle = title.split('?')[0];

    for (var item = 0; item < this.listTitles.length; item++) {
      if (
        this.listTitles[item].path === normalizedTitle ||
        normalizedTitle.startsWith(this.listTitles[item].path + '/')
      ) {
        return this.listTitles[item].title;
      }
    }

    // Admin routes that are intentionally not rendered in the sidebar.
    if (
      normalizedTitle === '/templates' ||
      normalizedTitle.startsWith('/templates/')
    ) {
      return 'Plantillas';
    }

    if (
      normalizedTitle === '/hr' ||
      normalizedTitle.startsWith('/hr/') ||
      normalizedTitle === '/team' ||
      normalizedTitle.startsWith('/team/')
    ) {
      return 'Recursos Humanos';
    }

    return 'Dashboard';
  }

  async logout(): Promise<void> {
    await this.authService.logout();
    this.router.navigate(['/login']);
  }

  navigateToProfile(): void {
    this.router.navigate(['/profile']);
  }

  get userInitials(): string {
    if (!this.currentUser) {
      return '';
    }

    const initials = [this.currentUser.name, this.currentUser.surname]
      .filter(Boolean)
      .map((value) => value.trim().charAt(0).toUpperCase())
      .join('');

    return initials.slice(0, 2);
  }
}
